import { PenTool } from "lucide-react";

export const Logo = ({ className = "", showText = true }) => {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <div className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-400 to-violet-600 glow-cyan">
        <PenTool className="h-5 w-5 text-[#060A12]" strokeWidth={2.5} />
      </div>
      {showText && (
        <span className="font-heading text-lg font-bold tracking-tight text-white">
          Sahabat<span className="text-gradient">PENA</span>
        </span>
      )}
    </div>
  );
};
